import { DxfUnit } from '../../elements/dxf/types';

/**
 *  Unit transformation table
 */
const getUnitMeterRelation = (unit: DxfUnit): number => {
  switch (unit) {
    case DxfUnit.Unitless:
      return NaN;
    case DxfUnit.Inches:
      return 0.0254;
    case DxfUnit.Feet:
      return 0.3048;
    case DxfUnit.Miles:
      return 1609.344;
    case DxfUnit.Millimeters:
      return 0.001;
    case DxfUnit.Centimeters:
      return 0.01;
    case DxfUnit.Meters:
      return 1;
    case DxfUnit.Kilometers:
      return 1000;
    case DxfUnit.Microinches:
      return 2.54e-10;
    case DxfUnit.Mils:
      return 10000;
    case DxfUnit.Yards:
      return 0.9144;
    case DxfUnit.Angstroms:
      return 1.0e-10;
    case DxfUnit.Nanometers:
      return 1.0e-9;
    case DxfUnit.Microns:
      return 1.0e-6;
    case DxfUnit.Decimeters:
      return 0.1;
    case DxfUnit.Decameters:
      return 10;
    case DxfUnit.Hectometers:
      return 100;
    case DxfUnit.Gigameters:
      return 1.0e9;
    case DxfUnit.Astronomicalunits:
      return 149597870700;
    case DxfUnit.Lightyears:
      return 9.4605284e15;
    case DxfUnit.Parsecs:
      return 3.08567758e16;
    case DxfUnit.Unknown:
      return NaN;
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Unknown unit supplied: ${unit}`);
  }
};

/**
 *  Retrieve the relation between to units
 */
export const getUnitRelation = (from: DxfUnit, to: DxfUnit) => {
  if (from === DxfUnit.Unitless || to === DxfUnit.Unitless) {
    throw new Error(`Can't get relation from or to unitless measures.`);
  }

  const fromMeterRelation = getUnitMeterRelation(from);
  const toMeterRelation = getUnitMeterRelation(to);

  return fromMeterRelation / toMeterRelation;
};
